import React, { useContext } from "react";
import { ShoppingCartContext } from "../../Providers/ShoppingCartProvider/ShoppingCartProvider";
import { accounting } from "accounting";

const CartTotals = () => {
    const { totals, products, paymentOptions } = useContext(
        ShoppingCartContext
    );

    return (
        <>
            <div className="flex justify-between mb-3 pb-3 border-b border-b-gray-400 text-gray-700">
                <span>Overzicht</span>
                <span>
                    {products.length}{" "}
                    {products.length === 1 ? "artikel" : "artikelen"}
                </span>
            </div>
            {products.map(product => (
                <div key={product.hash} className="flex justify-between mb-2 text-gray-700">
                    <span>{product.name}</span>
                    <span>
                        {accounting.formatMoney(
                            product.price,
                            "€",
                            2,
                            ".",
                            ","
                        )}
                    </span>
                </div>
            ))}
            <div className="flex justify-between mb-3 pb-3 border-b border-b-gray-400 text-gray-700">
                <span>Verzendkosten</span>
                <span className="font-bold text-green-400">gratis</span>
            </div>
            <div className="flex justify-between mb-2 text-gray-700">
                <span>Totaal (exclusief BTW)</span>
                <span>
                    {accounting.formatMoney(totals.ex, "€", 2, ".", ",")}
                </span>
            </div>
            <div className="flex justify-between mb-3 pb-3 border-b border-b-gray-400 text-gray-700">
                <span>BTW</span>
                <span>
                    {accounting.formatMoney(totals.tax, "€", 2, ".", ",")}
                </span>
            </div>
            <div className="flex justify-between mb-3 pb-3 border-b border-b-gray-400 text-gray-700">
                <span className="font-bold">Totaal (inclusief BTW)</span>
                <span className="font-bold">
                    {accounting.formatMoney(totals.in, "€", 2, ".", ",")}
                </span>
            </div>
            <div>
                <button
                    className="w-full text-center bg-yellow-200 text-yellow-900 px-4 py-2 rounded cursor-pointer font-bold hover:bg-yellow-300  uppercase"
                    onClick={() => window.location.replace(`/checkout`)}
                >
                    <span>Bestellen</span>
                    <i className="fas fa-chevron-right pl-2" />
                </button>
            </div>
        </>
    );
};

export default CartTotals;
